<template>
  <div class="order-return-address">
    <div class="header">
      <div class="title">出签回寄</div>
    </div>
    <div class="content">
      <div class="address-info">
        <div class="address-info-item">
          <div class="item-label">收件人姓名</div>
          <div class="item-content">{{order.return_address.addressee}}</div>
        </div>
        <div class="address-info-item">
          <div class="item-label">电话号码</div>
          <div class="item-content">{{order.return_address.mobile_phone}}</div>
        </div>
        <div class="address-info-item">
          <div class="item-label">邮箱地址</div>
          <div class="item-content">{{order.return_address.email}}</div>
        </div>
        <div class="address-info-item">
          <div class="item-label">收货地址</div>
          <div class="item-content">{{getAddress(pcds, order.return_address)}}</div>
        </div>
      </div>
      <div class="update-btn-box">
        <div v-if="!hideEditAddressBtn" class="update-btn s-btn btn-blue is-plain btn-xs" @click="showAddressDialog = true">修改信息</div>
      </div>
    </div>
    <add-or-edit-address-dialog
      title="订单收货地址"
      :show.sync="showAddressDialog"
      :address-info="order.return_address"
      :hide-cancel-btn="true"
      @success="handleEditAddressSuccess"
    >
      <button slot="other-btn" @click="showAddressListModel = true" class="s-btn btn-blue btn-lg is-plain">使用其他地址</button>
    </add-or-edit-address-dialog>

    <address-list-modal
      v-model="showAddressListModel"
      v-if="showAddressListModel"
      @select-address-success="selectAddressSuccess"
    >
    </address-list-modal>
  </div>
</template>
<script>
import addressUtils from '../../libs/address-utils';
import pcdService from '../../services/pcd-service';
import AddOrEditAddressDialog from '../address/add-or-edit-address-dialog';
import Http from '../../libs/http';
import utils from '../../libs/utils';
import addressListModal from '../../pages/ordering/modals/address-list-modal';

export default {
  name: '',
  components: {
    AddOrEditAddressDialog,
    addressListModal,
  },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      pcds: {},
      showAddressDialog: false,
      showAddressListModel: false,
    };
  },
  computed: {
    // 是否显示编辑地址按钮,由申请人出签了，则隐藏按钮
    hideEditAddressBtn() {
      return this.order.applicant.some(item => [5].indexOf(item.applicant_status) > -1);
    },
  },
  created() {
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });
  },
  methods: {
    getAddress: addressUtils.getAddress,
    handleEditAddressSuccess(addressInfo) {
      addressInfo.user_order_id = this.order.user_order_id;
      Http.post('/order_return_address_add', addressInfo)
        .then(() => {
          utils.msg.success('更新成功');
          this.$emit('refresh');
          this.showAddressDialog = false;
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    selectAddressSuccess(address) {
      this.handleEditAddressSuccess(address);
    },
  },
};
</script>
<style lang="less" scoped>
.order-return-address{
  margin-top: 15px;
  background: #fff;
  .header{
    display: flex;
    align-items: center;
    height: 44px;
    background:linear-gradient(270deg,rgba(255,255,255,1) 0,rgba(242,247,255,1) 800px);
    padding: 0 20px;
    .title{
      color: #2F333D;
      font-size: 16px;
      font-weight: 600;
      margin-right: 12px;
    }
  }
  .content{
    padding: 10px 24px;
    display: flex;
    .address-info{
      flex-grow: 1;
      overflow: hidden;
      padding: 6px 0;
      .address-info-item{
        display: flex;
        align-items: flex-start;
        line-height: 1;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
        .item-label{
          flex-shrink: 0;
          width: 96px;
          color: #91999F;
          font-size: 14px;
          line-height: 20px;
        }
        .item-content{
          flex-grow: 1;
          color: #2F333D;
          font-size: 14px;
          line-height: 20px;
          overflow: hidden;
          white-space: normal;
          word-break: break-all;
        }
      }
    }
    .update-btn-box{
      flex-shrink: 0;
      margin-left: 24px;
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-return-address.vue